import Swiper, { Navigation, Pagination, Autoplay } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/autoplay";

//パラメータは以下参照
//https://swiperjs.com/swiper-api#parameters

export function slider(sliderEl) {
  if ($(sliderEl).length) {
    const swiper = new Swiper(sliderEl, {
      direction: "horizontal",
      loop: true,
      autoHeight: false,
      centeredSlides: false,
      effect: "slide",
      modules: [Navigation, Pagination, Autoplay],
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
}
